if (!customElements.get("customer-stories")) {
  class CustomerStories extends HTMLElement {
    constructor() {
      super();
      this.customerCards = this.querySelectorAll(".customer-card");
      this.boundHandleCardClick = this.handleCardClick.bind(this);
      this.mainSwiperEl = this.querySelector(".main-swiper");
      this.gallerySwiperElList = this.querySelectorAll(
        ".stories-gallery-swiper"
      );
      this.paginationBullets = this.querySelectorAll(".pagination-bullet");
      this.sectionId = this.dataset.sectionId;
    }

    connectedCallback() {
      this.customerCards.forEach((card) => {
        card.addEventListener("click", this.boundHandleCardClick);
      });

      this.paginationBullets.forEach((bullet) => {
        bullet.addEventListener("click", () => {
          const index = parseInt(bullet.dataset.index);
          this.mainSwiper.slideTo(index);
          this.updatePaginationBullets(index);
          this.customerCards[index].click();
        });
      });

      this.waitForSwiper(() => {
        this.initMainSwiper();
      });

      document.addEventListener("DOMContentLoaded", () => {
        this.waitForSwiper(() => {
          this.initGallerySwipers();
        });
      });
    }

    waitForSwiper(callback) {
      if (typeof window.Swiper !== "undefined") {
        callback();
      } else {
        var check = setInterval(function () {
          if (typeof window.Swiper !== "undefined") {
            clearInterval(check);
            callback();
          }
        }, 50);
      }
    }

    disconnectedCallback() {
      this.customerCards.forEach((card) => {
        card.removeEventListener("click", this.boundHandleCardClick);
      });
    }

    handleCardClick(e) {
      const container = e.target.closest(".customer-card");
      const forId = container.dataset.for;

      const activeVideo = this.querySelector('.customer-story-video-active iframe');

      if(activeVideo) {
        activeVideo.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      }

      if (e.isTrusted) {
        const index = Array.from(this.customerCards).indexOf(container);
        this.updatePaginationBullets(index);
      }

      this.querySelector(
        ".customer-card.customer-card-active"
      ).classList.remove("customer-card-active");
      container.classList.add("customer-card-active");

      this.querySelector(
        `.customer-story-video.customer-story-video-active`
      ).classList.remove("customer-story-video-active");
      this.querySelector(
        `.customer-story-video[data-for="${forId}"]`
      ).classList.add("customer-story-video-active");

      this.querySelector(
        ".customer-story-feedback-header.customer-story-feedback-header-active"
      ).classList.remove("customer-story-feedback-header-active");
      this.querySelector(
        `.customer-story-feedback-header[data-for="${forId}"]`
      ).classList.add("customer-story-feedback-header-active");

      [...this.querySelectorAll(
        ".customer-story-feedback-content.customer-story-feedback-content-active"
      )].forEach((item) => item.classList.remove("customer-story-feedback-content-active"));
      [...this.querySelectorAll(
        `.customer-story-feedback-content[data-for="${forId}"]`
      )].forEach((item) => item.classList.add("customer-story-feedback-content-active"));

      this.querySelector(
        ".customer-story-gallery.customer-story-gallery-active"
      ).classList.remove("customer-story-gallery-active");
      this.querySelector(
        `.customer-story-gallery[data-for="${forId}"]`
      ).classList.add("customer-story-gallery-active");
    }

    updatePaginationBullets(activeIndex) {
      this.paginationBullets.forEach((bullet) => {
        bullet.classList.remove("pagination-bullet-active");
      });
      this.paginationBullets[activeIndex].classList.add(
        "pagination-bullet-active"
      );
    }

    initMainSwiper() {
      this.mainSwiper = new Swiper(this.mainSwiperEl, {
        slidesPerView: "auto",
        spaceBetween: 16,
        navigation: {
          nextEl: `.swiper-icon-right#swiper-right-main-swiper-${this.sectionId}`,
          prevEl: `.swiper-icon-left#swiper-left-main-swiper-${this.sectionId}`,
        },
      });

      const nextArrow = document.querySelector(`.swiper-icon-right#swiper-right-main-swiper-${this.sectionId}`);
      const prevArrow = document.querySelector(`.swiper-icon-left#swiper-left-main-swiper-${this.sectionId}`);

      nextArrow?.addEventListener('click', () => {
        const currentIndex = Array.from(this.customerCards).findIndex(card => 
          card.classList.contains('customer-card-active')
        );
        const nextIndex = (currentIndex + 1) % this.customerCards.length;
        this.mainSwiper.slideTo(nextIndex);
        this.customerCards[nextIndex].click();
        this.updatePaginationBullets(nextIndex);
      });

      prevArrow?.addEventListener('click', () => {
        const currentIndex = Array.from(this.customerCards).findIndex(card => 
          card.classList.contains('customer-card-active')
        );
        const prevIndex = (currentIndex - 1 + this.customerCards.length) % this.customerCards.length;
        this.mainSwiper.slideTo(prevIndex);
        this.customerCards[prevIndex].click();
        this.updatePaginationBullets(prevIndex);
      });
    }

    initGallerySwipers() {
      this.gallerySwiperElList.forEach((el) => {
        const elSwiper = new Swiper(el, {
          slidesPerView: "auto",
          spaceBetween: 8,
          loop: true,
          speed: 15000,
          breakpoints: {
            990: {
              speed: 10000,
              slidesPerView: 4,
            },
          },
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
        });
      });
    }
  }

  customElements.define("customer-stories", CustomerStories);
}
